/* 移动端 渠道链接  */

const deeplinks: { [key: string]: any } = {
  //开发环境
  development: {
    ios: {
      homepage_nav_button: "https://app.adjust.com/mh8zuw6?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
      dialog_open_app: "https://app.adjust.com/mh8zuw6?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
    },
    android: {
      homepage_nav_button: "https://app.adjust.com/5t0c3sp?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
      dialog_open_app: "https://app.adjust.com/5t0c3sp?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
    }
  },

  //正式环境
  production: {
    ios: {
      homepage_nav_button: "https://app.adjust.com/mh8zuw6?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
      dialog_open_app: "https://app.adjust.com/mh8zuw6?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
    },
    android: {
      homepage_nav_button: "https://app.adjust.com/5t0c3sp?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
      dialog_open_app: "https://app.adjust.com/5t0c3sp?campaign=goart.fotor.com%2F&adgroup=inner-button&deep_link=fotor%3A%2F%2FfuntionExperience%2Fhome%3Ftype%3Dai_art_effects%26channel%3Dweb%26url%3Dgoart.fotor.com%2F%26adgroup%3Dinner-button",
    }
  }
};
deeplinks.staging = deeplinks.development;
deeplinks.preRelease = deeplinks.production;
const env = process.env.NODE_ENV === 'production' ? "production" : "development";
export default deeplinks[env];
